import React from "react";

import { Spinner } from "./Spinner";

export const LoadingIndicator = (props: { title: string; size?: number }) => (
  <div
    role="status"
    title={props.title}
    style={{ height: props.size ?? 200 }}
    className="flex w-full items-center justify-center"
  >
    <Spinner size={props.size} aria-hidden={true} />
    <span className="sr-only">{props.title}</span>
  </div>
);
